// extracted by mini-css-extract-plugin
export default {"summaryCount":"StackedSummaryBar--summaryCount--g99eK","barSection":"StackedSummaryBar--barSection--MDiNJ"};